
















import MarkdownItVue from 'markdown-it-vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'ExtendedDescription',
  components: {MarkdownItVue},
  computed:{
    shortDescription() :string{
      const desc = this.text
      if (desc && desc.indexOf("\n") > 0) {
        return desc.substring(0, desc.indexOf("\n"));
      }
      return desc;
    },
    extraDescription() :string|null{
      const desc = this.text
      if (desc && desc.indexOf("\n") > 0) {
        return desc.substring(desc.indexOf("\n") + 1);
      }
      return null;
    }
  },
  props: {
    'text': {
      type: String,
      required: false,
      default: ''
    },
    'extendedCss': {
      type: String,
      required: false,
      default: ''
    },
    'descriptionCss': {
      type: String,
      required: false,
      default: ''
    },
    'basicCss': {
      type: String,
      required: false,
      default: ''
    }
  }
})

